package com.wintermar.inspection.feature.presentation.inspection.complete.widget.page_info

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.feature.domain.model.answer.SummaryAnswerModel
import com.wintermar.inspection.util.Constant

@Composable
fun PageInfoSideMenu(
    flaggedItems: List<SummaryAnswerModel>,
    onClick: (page: String) -> Unit
) {
    val dimension = LocalAppTheme.current.dimension
    val spaceItem = dimension.spacing.space4
    LazyColumn {
        item {
            Spacer(modifier = Modifier.height(dimension.spacing.space5))
        }

        item {
            ClickableContent(
                text = Constant.OVERVIEW_KEY,
                modifier = Modifier.padding(bottom = spaceItem),
                onClick = onClick
            )
        }

        if (flaggedItems.isNotEmpty()) {
            item {
                ClickableContent(
                    text = Constant.FLAGGED_ITEM_KEY,
                    modifier = Modifier.padding(bottom = spaceItem),
                    onClick = onClick
                )
            }
            flaggedItems.groupBy { it.pageTitle }.forEach { (page, sections) ->
                item {
                    Column(
                        modifier = Modifier.padding(
                            bottom = spaceItem
                        ),
                        verticalArrangement = Arrangement.spacedBy(
                            space = spaceItem
                        )
                    ) {
                        ClickableContent(
                            text = page,
                            onClick = onClick
                        )

                        // Group sections by title, then flatten all questions from all sections
                        sections.groupBy { it.sectionTitle }.flatMap { (_, questions) ->
                            questions.map { it.question.questionText }
                        }.forEach { questionText ->
                            TextBodySmall(
                                text = questionText,
                                color = { it.subtle },
                                modifier = Modifier
                                    .padding(
                                        start = dimension.spacing.space6
                                    )
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun ClickableContent(
    text: String,
    modifier: Modifier = Modifier,
    onClick: (page: String) -> Unit
) {
    TextBodySmall(
        text = text,
        modifier = modifier
            .clickable {
                onClick(text)
            }
    )
}
